@if (!!content?.title) {
<h3 class="m-t h2"
    *iCms="'title' of content"></h3>
}